import React, {FC, MouseEventHandler, ReactNode, useCallback} from 'react';
import Link, {LinkProps} from 'components/CustomRoutingLink';
import {PREVENT_DEFAULT_HANDLER_MARKER, STOP_PROP_HANDLER_MARKER} from 'core/constants';

interface IProps extends LinkProps {
    children: ReactNode;
    className?: string;
    fullReload?: boolean;
    ['data-skeleton-item']?: boolean;
}

export const PrevDefaultLink: FC<IProps> = ({className, fullReload, children, onClick, ...restNextLinkAttributes}) => {
    const handleLinkClick = useCallback<MouseEventHandler<HTMLAnchorElement>>(
        (event) => {
            const target = event.target as HTMLAnchorElement;
            const targetNodePreventDefault = target.closest(`[${PREVENT_DEFAULT_HANDLER_MARKER}='true']`);
            const targetNodeStopProp = target.closest(`[${STOP_PROP_HANDLER_MARKER}='true']`);

            onClick?.(event);

            if (targetNodePreventDefault) {
                event.preventDefault();
            }

            if (targetNodeStopProp) {
                event.stopPropagation();
            }

            if (fullReload) {
                window.location.href = restNextLinkAttributes.href as string;
            }
        },
        [fullReload, onClick, restNextLinkAttributes.href],
    );

    return (
        <Link
            {...restNextLinkAttributes}
            className={className}
            data-skeleton-item={restNextLinkAttributes['data-skeleton-item']}
            onClick={handleLinkClick}
        >
            {children}
        </Link>
    );
};
